import React, { useMemo } from 'react'
import Scroll from 'react-scroll'
import MovieInformation from '../../MovieInformation'
import MovieDetails from '../../MovieDetails'
import PerformanceSection from '../../PerformancePage/PerformanceSection'
import { SiteSlidebarRight, SiteSlidebarRightSecond } from '../../General/SiteSlidebars'
import { trackMovieDetailsClose, trackMovieDetailsOpen, trackMovieInformationClose, trackMoviePerformanceClose, trackMoviePerformanceOpen } from '../../tracking'
import getBackgroundsUrlsObj from '../../functions/getBackgroundsUrlsObj'
import hasToggleMovieDatesOnMobile from '../../hoc/hasToggleMovieDatesOnMobile'

let Element = Scroll.Element

const GridMovieInformation = ({
    activeItem, 
    activeDetailsItem,
    itemsData,
    elbenwald,
    itemLink,
    closeItemInformation, 
    closeItemDetails, 
    openItemDetails,
    movieInformationOrder, 
    row, 
    theme,
    attributeStyling,
    displaySidebarRight, 
    displaySidebarRightSecond,
    toggleMovieDatesOnMobileView,
    currentDateActive,
    activePerformance,
    dayFilters,
    informationStyling,
    performancePageOpen,
    isMobile,
    ignoreAttributesForPerformanceFilter,
    overviewFilterIgnoreOnPerformances,
    onOpenPerformancePage,
    onClosePerformancePage,
    detailsStyling,
    queryStringValues,
    eventOrigins,
    additionalScrollName,
    translation,
    hideCinemaSelector,
    clusterCinemaActive,
    clusterCinemaOption,
    activeCinema,
    hasMerchandising
}) => {
    if (!itemsData) {
        return ''
    }
    const movieData = itemsData[activeItem]

    if (!movieData || !activeItem) {
        return ''
    }

    const backgroundsObj = useMemo(
        () => getBackgroundsUrlsObj(movieData.images), 
        [movieData.images]
    )

    const styles = {
        order: movieInformationOrder,
        msGridRow: row
    }

    const detailsOpen = activeDetailsItem === activeItem
    const isOpen = activeDetailsItem ? ' is-open' : ''

    return (
        <div className={"order-wrapper movie-information-is-open" + isOpen} style={styles}>
            {!displaySidebarRight && !performancePageOpen && 
                <MovieInformation
                    itemID={activeItem}
                    elbenwald={elbenwald}
                    theme={theme}
                    informationStyling={informationStyling}
                    attributeStyling={attributeStyling}
                    isMobile={isMobile}
                    activePerformance={activePerformance}
                    queryStringValues={queryStringValues}
                    moviesData={itemsData}
                    itemLink={itemLink}
                    overviewFilterIgnoreOnPerformances={overviewFilterIgnoreOnPerformances}
                    ignoreAttributesForPerformanceFilter={ignoreAttributesForPerformanceFilter}
                    translation={translation}
                    clusterCinemaActive={clusterCinemaActive}
                    clusterCinemaOption={clusterCinemaOption}
                    activeCinema={activeCinema}
                    dayFilters={dayFilters}
                    detailsOpen={detailsOpen}
                    backgroundImage={backgroundsObj.performance}
                    trailerImage={backgroundsObj.ambient}
                    scrollToPosition={activeItem + additionalScrollName}
                    onOpenDetails={trackMovieDetailsOpen(openItemDetails, eventOrigins.information)}
                    onCloseDetails={trackMovieDetailsClose(closeItemDetails, eventOrigins.information)}
                    onCloseInformation={trackMovieInformationClose(closeItemInformation, eventOrigins.information)}
                    onOpenIframe={trackMoviePerformanceOpen(onOpenPerformancePage, eventOrigins.information)}
                    toggleMovieDatesOnMobileView={toggleMovieDatesOnMobileView}
                    hideCinemaSelector={hideCinemaSelector}
                    hasMerchandising={hasMerchandising}
                />
            }
            
            {!displaySidebarRight && !displaySidebarRightSecond && performancePageOpen && <PerformanceSection
                itemID={activeItem}
                hideCinemaSelector={hideCinemaSelector}
                informationStyling={informationStyling}
                clusterCinemaActive={clusterCinemaActive}
                clusterCinemaOption={clusterCinemaOption}
                overviewFilterIgnoreOnPerformances={overviewFilterIgnoreOnPerformances}
                theme={theme}
                activeCinema={activeCinema}
                isMobile={isMobile}
                activePerformance={activePerformance}
                moviesData={itemsData}
                queryStringValues={queryStringValues}
                translation={translation}
                backgroundImage={backgroundsObj.performance}
                scrollToPosition={activeItem + additionalScrollName}
                currentDateActive={currentDateActive}
                toggleMovieDatesOnMobileView={toggleMovieDatesOnMobileView}
                onOpenPerformancePage={trackMoviePerformanceOpen(onOpenPerformancePage, eventOrigins.performance)}
                onClosePerformancePage={trackMoviePerformanceClose(onClosePerformancePage, eventOrigins.performance)}
                />}

            <Element name={activeItem + additionalScrollName + ' movieDetails'}></Element>

            {!displaySidebarRightSecond && detailsOpen &&
                <MovieDetails
                    itemID={activeItem}
                    theme={theme}
                    translation={translation}
                    detailsStyling={detailsStyling}
                    trailerImage={backgroundsObj.ambient}
                    moviesData={itemsData}
                    attributeStyling={attributeStyling}
                    backgroundImage={backgroundsObj.details}
                    isMobile={isMobile}
                    scrollToPosition={activeItem + additionalScrollName}
                    onCloseDetails={trackMovieDetailsClose(closeItemDetails, eventOrigins.details)}
                />
            }

            {displaySidebarRight && 
                <SiteSlidebarRight>
                    <div className="site-slidebar-overlay accent-color-background-half-transparent" onClick={closeItemInformation} />
                    <div className="site-slidebar-content accent-color-background-half-transparent">
                        <MovieInformation
                            attributeStyling={attributeStyling}
                            theme={theme}
                            itemID={activeItem}
                            translation={translation}
                            moviesData={itemsData}
                            ignoreAttributesForPerformanceFilter={ignoreAttributesForPerformanceFilter}
                            overviewFilterIgnoreOnPerformances={overviewFilterIgnoreOnPerformances}
                            elbenwald={elbenwald}
                            itemLink={itemLink}
                            hideCinemaSelector={true}
                            informationStyling={informationStyling}
                            dayFilters={dayFilters}
                            detailsOpen={detailsOpen}
                            isMobile={isMobile}
                            queryStringValues={queryStringValues}
                            backgroundImage={backgroundsObj.performance}
                            trailerImage={backgroundsObj.ambient}
                            scrollToPosition={activeItem + additionalScrollName}      
                            activePerformance={activePerformance}
                            onOpenDetails={trackMovieDetailsOpen(openItemDetails, eventOrigins.informationSlidebar)}
                            onCloseDetails={trackMovieDetailsClose(closeItemDetails, eventOrigins.informationSlidebar)}
                            onCloseInformation={trackMovieInformationClose(closeItemInformation, eventOrigins.informationSlidebar)}
                            toggleMovieDatesOnMobileView={toggleMovieDatesOnMobileView}
                            onOpenIframe={trackMoviePerformanceOpen(onOpenPerformancePage, eventOrigins.informationSlidebar)}
                            currentDateActive={currentDateActive}
                        />
                    </div>
                </SiteSlidebarRight>
            }

            {displaySidebarRightSecond && performancePageOpen && <SiteSlidebarRightSecond>
                <PerformanceSection
                    overviewFilterIgnoreOnPerformances={overviewFilterIgnoreOnPerformances}
                    theme={theme}
                    informationStyling={informationStyling}
                    displaySidebarRight={displaySidebarRight}
                    itemID={activeItem}
                    translation={translation}
                    activePerformance={activePerformance}
                    queryStringValues={queryStringValues}
                    isMobile={isMobile}
                    moviesData={itemsData}
                    scrollToPosition={activeItem + additionalScrollName}
                    currentDateActive={currentDateActive}
                    backgroundImage={backgroundsObj.performance}
                    performancePageMovieTimes={true}
                    toggleMovieDatesOnMobileView={toggleMovieDatesOnMobileView}
                    onOpenPerformancePage={trackMoviePerformanceOpen(onOpenPerformancePage, eventOrigins.performance)}
                    onClosePerformancePage={trackMoviePerformanceClose(onClosePerformancePage, eventOrigins.performance)}
                />
            </SiteSlidebarRightSecond>}

            {displaySidebarRightSecond && detailsOpen &&
                <SiteSlidebarRightSecond>
                    <div className="site-slidebar-overlay accent-color-background-half-transparent" onClick={trackMovieDetailsClose(() => closeItemDetails({movieTitle: movieData.title}), eventOrigins.detailsSlidebar)} />

                    <div className="site-slidebar-content accent-color-background-half-transparent">
                        <MovieDetails
                            itemID={activeItem}
                            translation={translation}
                            moviesData={itemsData}
                            attributeStyling={attributeStyling}
                            theme={theme}
                            trailerImage={backgroundsObj.ambient}
                            isMobile={isMobile}
                            detailsStyling={detailsStyling}
                            backgroundImage={backgroundsObj.details}
                            scrollToPosition={activeItem + additionalScrollName}
                            onCloseDetails={trackMovieDetailsClose(closeItemDetails, eventOrigins.detailsSlidebar)}
                        />
                    </div>

                </SiteSlidebarRightSecond>
            }
        </div>
    )
}


export default hasToggleMovieDatesOnMobile(GridMovieInformation)